import { Pipe, PipeTransform, inject } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({standalone: true, name: 'safeResourceUrl'})
export class SafeResourceUrlPipe implements PipeTransform {
    private sanitizer = inject(DomSanitizer);



    constructor() {
    }

    transform(value: any, args?: any): any {
        return value ? this.sanitizer.bypassSecurityTrustResourceUrl(value) : '';
    }
}
